// src/shared/utils/colorScales.js
//
// getScoreColor was previously duplicated verbatim inside both
// components/ScoreBar.jsx and components/ScoreRing.jsx. Pulled out here so
// any component that renders a 0-100 score (health scores, coverage
// scores, confidence scores...) uses one tier scale instead of each
// copying/pasting (and risking drifting) the thresholds.

/**
 * 5-tier color scale for a 0-100 score: green (>=80) -> blue (>=70) ->
 * amber (>=50) -> orange (>=30) -> red (below).
 * Returns solid color, a translucent background tint, and a glow tint
 * (used for shadow/drop-shadow effects).
 */
export function getScoreColor(score) {
  const n = Number(score) || 0;
  if (n >= 80) return { color: "#10b981", bgColor: "rgba(16, 185, 129, 0.2)", glowColor: "rgba(16, 185, 129, 0.3)" };
  if (n >= 70) return { color: "#3b82f6", bgColor: "rgba(59, 130, 246, 0.2)", glowColor: "rgba(59, 130, 246, 0.3)" };
  if (n >= 50) return { color: "#fbbf24", bgColor: "rgba(251, 191, 36, 0.2)", glowColor: "rgba(251, 191, 36, 0.3)" };
  if (n >= 30) return { color: "#f97316", bgColor: "rgba(249, 115, 22, 0.2)", glowColor: "rgba(249, 115, 22, 0.3)" };
  return { color: "#ef4444", bgColor: "rgba(239, 68, 68, 0.2)", glowColor: "rgba(239, 68, 68, 0.3)" };
}

/** Severity -> tone, shared by codebase's Badge/FindingsTable and anywhere else that renders finding severities. */
export function getSeverityTone(severity) {
  const s = String(severity || "").toLowerCase();
  if (s === "critical") return "red";
  if (s === "high") return "orange";
  if (s === "medium") return "yellow";
  if (s === "low") return "blue";
  return "muted";
}
